var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 9.33366C7.26297 9.33366 6.66602 8.73671 6.66602 8.00033C6.66602 7.26395 7.26297 6.66699 7.99935 6.66699C8.73573 6.66699 9.33268 7.26395 9.33268 8.00033C9.33268 8.35395 9.19221 8.69309 8.94216 8.94313C8.69211 9.19318 8.35297 9.33366 7.99935 9.33366Z",
    stroke: "#999B9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5443 10.7088V9.81416C11.5443 9.59261 11.6323 9.38014 11.789 9.22349L12.4217 8.59082C12.7479 8.26461 12.7479 7.73571 12.4217 7.40949L11.789 6.77682C11.6323 6.62017 11.5443 6.4077 11.5443 6.18616V5.29082C11.5443 4.82948 11.1703 4.45549 10.709 4.45549H9.81367C9.59212 4.45549 9.37966 4.36748 9.223 4.21082L8.59034 3.57816C8.26412 3.25194 7.73522 3.25194 7.409 3.57816L6.77633 4.21082C6.61968 4.36748 6.40721 4.45549 6.18567 4.45549H5.29033C5.06868 4.45549 4.8561 4.54359 4.69943 4.70039C4.54275 4.85719 4.45482 5.06983 4.455 5.29149V6.18616C4.455 6.4077 4.36699 6.62017 4.21033 6.77682L3.57767 7.40949C3.25145 7.73571 3.25145 8.26461 3.57767 8.59082L4.21033 9.22349C4.36699 9.38014 4.455 9.59261 4.455 9.81416V10.7088C4.455 11.1702 4.82899 11.5442 5.29033 11.5442H6.18567C6.40721 11.5442 6.61968 11.6322 6.77633 11.7888L7.409 12.4215C7.73522 12.7477 8.26412 12.7477 8.59034 12.4215L9.223 11.7888C9.37966 11.6322 9.59212 11.5442 9.81367 11.5442H10.7083C10.93 11.5443 11.1426 11.4564 11.2994 11.2997C11.4562 11.1431 11.5443 10.9305 11.5443 10.7088Z",
    stroke: "#999B9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.a663d26c91b808fedb8a082f028315e9.svg";
export { ForwardRef as ReactComponent };